import _map from "lodash/map";
import Button from '@datacamp/waffles-button';
import React from 'react';
import { InputFieldAdapter } from './InputFieldAdapter';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const InputFields = _ref => {
  let {
    bottomLeftContent,
    checkExercise,
    items,
    lastAttempts = [],
    submitLabel = 'Submit Answer'
  } = _ref;
  const [submitExerciseCount, setSubmitExerciseCount] = React.useState(0);
  const checkAnswersOnExercise = React.useCallback(event => {
    setSubmitExerciseCount(submitExerciseCount + 1);
    event.preventDefault();
  }, [submitExerciseCount]);
  const [answers, setAnswer] = React.useState([]);
  const checkInputField = React.useCallback((message, success, submittedCode) => {
    setAnswer(previousAnswers => [...previousAnswers, {
      message,
      submittedCode,
      success
    }]);
  }, []);
  React.useEffect(() => {
    if (answers.length === items.length) {
      const succeedAll = answers.reduce((acc, _ref2) => {
        let {
          success
        } = _ref2;
        return acc && success;
      }, true);
      checkExercise(_map(answers, 'message').join('\n'), succeedAll, _map(answers, 'submittedCode').join('\n'));
      setAnswer([]);
    }
  }, [answers, items, checkExercise]);
  return ___EmotionJSX("div", {
    className: "dc-panel__body"
  }, ___EmotionJSX("form", {
    onSubmit: checkAnswersOnExercise
  }, ___EmotionJSX(React.Fragment, null, items.map((item, index) => ___EmotionJSX(InputFieldAdapter, {
    checkExercise: checkInputField,
    item: item,
    key: index,
    lastAttempt: lastAttempts[index],
    submitExerciseCount: submitExerciseCount
  }))), ___EmotionJSX("div", {
    className: "dc-u-mt-16",
    style: {
      display: 'flex',
      justifyContent: bottomLeftContent ? 'space-between' : 'flex-end'
    }
  }, bottomLeftContent === null || bottomLeftContent === void 0 ? void 0 : bottomLeftContent.map(component => component), ___EmotionJSX(Button, {
    appearance: "primary",
    dataAttributes: {
      cy: 'submit-answer'
    },
    intent: "success",
    size: "small",
    type: "submit"
  }, submitLabel))));
};